/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import AppointmentAction from 'DesignSystem/AppointmentAction/index'
import CancelAppointment from 'DesignSystem/CancelAppointment/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CancelAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/NextAppointment/Content/Content/Content/AppointmentOptions/CancelAction"
  
}) {
let upcomingAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'upcoming_appointment',
path: '_id',
})
let onActionComplete = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
  return (<React.Fragment
>
<CancelAppointment
  viewPath={`${viewPath}/CancelAppointment`}
 data="upcoming_appointment._id"
 id={upcomingAppointmentIdValueData}
 onActionComplete={onActionComplete}
>
{childProps => (
<AppointmentAction
{...childProps}
  viewPath={`${viewPath}/AppointmentAction`}
 text="Cancel appointment"
 color={dtColorsRed600}
/>
)}
</CancelAppointment>
{children}
</React.Fragment>)
}